export enum EntraGroupKey {
  SuperAdmins = 0,
  Admins = 1,
  ImprovementLeadersExtended = 2,
  ImprovementLeaders = 3,
}

export interface EntraGroup {
  key: EntraGroupKey;
  urlKey: string;
  translationKey: string;
}

export const entraGroups: EntraGroup[] = [
  {
    key: EntraGroupKey.SuperAdmins,
    urlKey: "super-admins",
    translationKey: "superAdmins",
  },
  {
    key: EntraGroupKey.Admins,
    urlKey: "admins",
    translationKey: "admins",
  },
  {
    key: EntraGroupKey.ImprovementLeadersExtended,
    urlKey: "improvement-leaders-extended",
    translationKey: "improvementLeadersExtended",
  },
  {
    key: EntraGroupKey.ImprovementLeaders,
    urlKey: "improvement-leaders",
    translationKey: "improvementLeaders",
  },
];

export function getEntraGroupFromUrlKey(
  urlKey: string | null
): EntraGroup | null {
  return entraGroups.find((group) => group.urlKey === urlKey) ?? null;
}

export function getEntraGroupKeyFromSearchParams(
  searchParams: URLSearchParams
): EntraGroupKey | null {
  const groupUrlKeys = searchParams.getAll("group");

  if (groupUrlKeys.length !== 1) return null;

  return getEntraGroupFromUrlKey(groupUrlKeys[0])?.key ?? null;
}

export interface EntraUser {
  id: string;
  displayName: string;
  email: string | null;
}

export interface AddEntraGroupMemberRequest {
  groupKey: EntraGroupKey;
  userObjectId: string;
}

export interface EntraGroupMember {
  id: string;
  displayName: string;
  email: string | null;
}

export interface RemoveEntraGroupMemberRequest {
  groupKey: EntraGroupKey;
  memberObjectId: string;
}
